import React from 'react';
import { Helmet } from 'react-helmet-async';

/**
 * Component for adding structured data (Schema.org) to pages
 * @param {Object} props - Component props
 * @param {Object} props.data - Structured data object
 */
const StructuredData = ({ data }) => {
  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(data)}
      </script>
    </Helmet>
  );
};

export default StructuredData;

/**
 * Generate Organization schema
 * @returns {Object} Organization schema
 */
export const generateOrganizationSchema = () => {
  return {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    'name': 'DomikTyumen',
    'url': 'https://domiktyumen.ru',
    'logo': 'https://domiktyumen.ru/assets/logo/logo.png',
    'description': 'Аренда квартир, домов и коттеджей в Тюмени. Большой выбор недвижимости для комфортного проживания.',
    'address': {
      '@type': 'PostalAddress',
      'addressLocality': 'Тюмень',
      'addressRegion': 'Тюменская область',
      'addressCountry': 'RU'
    },
    'contactPoint': {
      '@type': 'ContactPoint',
      'telephone': '+7-XXX-XXX-XXXX',
      'contactType': 'customer service'
    },
    'sameAs': [
      'https://vk.com/domiktyumen',
      'https://t.me/domiktyumen'
    ]
  };
};

/**
 * Generate RealEstateListing schema for a property
 * @param {Object} property - Property data
 * @returns {Object} RealEstateListing schema
 */
export const generatePropertySchema = (property) => {
  if (!property) return null;
  
  return {
    '@context': 'https://schema.org',
    '@type': 'RealEstateListing',
    'name': property.title,
    'description': property.description,
    'url': `https://domiktyumen.ru/property/${property.id}`,
    'image': property.images && property.images.length > 0 ? property.images[0] : '',
    'datePosted': property.createdAt,
    'address': {
      '@type': 'PostalAddress',
      'addressLocality': 'Тюмень',
      'addressRegion': 'Тюменская область',
      'addressCountry': 'RU',
      'streetAddress': property.location || ''
    },
    'offers': {
      '@type': 'Offer',
      'price': property.price,
      'priceCurrency': 'RUB',
      'availability': property.isAvailable ? 'https://schema.org/InStock' : 'https://schema.org/OutOfStock'
    },
    'numberOfRooms': property.bedrooms,
    'floorSize': {
      '@type': 'QuantitativeValue',
      'value': property.area,
      'unitCode': 'MTK'
    }
  };
};

/**
 * Generate BreadcrumbList schema
 * @param {Array} items - Breadcrumb items
 * @returns {Object} BreadcrumbList schema
 */
export const generateBreadcrumbSchema = (items) => {
  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    'itemListElement': items.map((item, index) => ({
      '@type': 'ListItem',
      'position': index + 1,
      'name': item.name,
      'item': `https://domiktyumen.ru${item.path}`
    }))
  };
};

/**
 * Generate LocalBusiness schema
 * @returns {Object} LocalBusiness schema
 */
export const generateLocalBusinessSchema = () => {
  return {
    '@context': 'https://schema.org',
    '@type': 'LocalBusiness',
    'name': 'DomikTyumen',
    'image': 'https://domiktyumen.ru/assets/logo/logo.png',
    'url': 'https://domiktyumen.ru',
    'telephone': '+7-XXX-XXX-XXXX',
    'address': {
      '@type': 'PostalAddress',
      'streetAddress': 'ул. Примерная, 123',
      'addressLocality': 'Тюмень',
      'addressRegion': 'Тюменская область',
      'postalCode': '625000',
      'addressCountry': 'RU'
    },
    'geo': {
      '@type': 'GeoCoordinates',
      'latitude': '57.1522',
      'longitude': '65.5272'
    },
    'openingHoursSpecification': [
      {
        '@type': 'OpeningHoursSpecification',
        'dayOfWeek': [
          'Monday',
          'Tuesday',
          'Wednesday',
          'Thursday',
          'Friday'
        ],
        'opens': '09:00',
        'closes': '18:00'
      },
      {
        '@type': 'OpeningHoursSpecification',
        'dayOfWeek': [
          'Saturday'
        ],
        'opens': '10:00',
        'closes': '17:00'
      }
    ],
    'priceRange': '₽₽'
  };
};
